<div>
  <ng-container *ngIf="SIMPublicationKeyDates && !loading">
    <div class="flex flex-col">
      <div class="mt-4 mb-16 ml-4">
        <div class="flex flex-col lg:flex-row text-grey-800" >
          <div class="lg:w-1/3 lg:px-4" >
            <div
              id="div-publish-date"
            >
              <label class="body-default-bold" id="sim-publication-document-publish-date-label">Publish Date</label>
              <p class="body-default-regular" id="sim-publication-document-publish-date-value">
                {{SIMPublicationKeyDates?.publishDate | dateFormat}}
              </p>
            </div>
            <div
              id="div-release-date"
            >
              <label class="body-default-bold" id="sim-publication-release-date-label">Release Date</label>
              <p class="body-default-regular" id="sim-publication-release-date-value">
                  {{SIMPublicationKeyDates?.releaseDate | dateFormat}}
              </p>
            </div>
            <div
              id="div-vote-start-date"
            >
              <label class="body-default-bold" id="sim-publication-vote-start-date-label">Vote Start Date</label>
              <p class="body-default-regular " id="sim-publication-vote-start-date-value">
                  {{SIMPublicationKeyDates?.voteStartDate | dateFormat}}
              </p>
            </div>
            <div
              id="div-vote-end-date"
            >
              <label class="body-default-bold" id="sim-publication-vote-end-date-label">Vote End Date</label>
              <p class="body-default-regular" id="sim-publication-vote-end-date-value">
                  {{SIMPublicationKeyDates?.voteEndDate | dateFormat}}
              </p>
            </div>
            <div
              id="div-sa-approval-date"
            >
              <label class="body-default-bold" id="sim-publication-sa-approval-date-label">SA Approval Date</label>
              <p class="body-default-regular" id="sim-publication-sa-approval-date-value">
                  {{SIMPublicationKeyDates?.saApprovalDate | dateFormat}}
              </p>
            </div>
            <div
              id="div-snz-approval-date"
            >
              <label class="body-default-bold" id="sim-publication-snz-approval-dat-label">SNZ Approval Date</label>
              <p class="body-default-regular" id="sim-publication-snz-approval-dat-value">
                  {{SIMPublicationKeyDates?.snzApprovalDate | dateFormat}}
              </p>
            </div>
          </div>
          <div class="lg:w-2/3 lg:px-4">
            <div id="div-reconfirmation-date">
              <label class="body-default-bold" id="sim-publication-reconfirmation-date-label">Reconfirmation Date</label>
              <p class="body-default-regular " id="sim-publication-reconfirmation-date-value">
                  {{SIMPublicationKeyDates?.reconfirmationDate | dateFormat}}
              </p>
            </div>
            <div id="div-interim-to-full-date">
              <label class="body-default-bold" id="sim-publication-interim-to-full-date-label">Interim to Full Date</label>
              <p class="body-default-regular " id="sim-publication-interim-to-full-date-value">
                  {{SIMPublicationKeyDates?.interimToFullDate | dateFormat}}
              </p>
            </div>
            <div id="div-interim-start-date">
              <label class="body-default-bold" id="sim-publication-interim-start-date-label">Interim Start Date</label>
              <p class="body-default-regular " id="sim-publication-interim-start-date-value">
                  {{SIMPublicationKeyDates?.interimStartDate | dateFormat}}
              </p>
            </div>
            <div id="div-interim-end-date">
              <label class="body-default-bold" id="sim-publication-interim-end-date-label">Interim End Date</label>
              <p class="body-default-regular " id="sim-publication-interim-end-date-value">
                  {{SIMPublicationKeyDates?.interimEndDate | dateFormat}}
              </p>
            </div>
            <div id="div-withdrawal-date">
              <label class="body-default-bold" id="sim-publication-withdrawal-date-label">Withdrawal Date</label>
              <p class="body-default-regular " id="sim-publication-withdrawal-date-value">
                  {{SIMPublicationKeyDates?.withdrawalDate | dateFormat}}
              </p>
            </div>
            <div id="div-publication-review-date">
              <label class="body-default-bold" id="sim-publication-review-date-label">Publication Review Date</label>
              <p class="body-default-regular " id="sim-publication-review-date-value">
                  {{SIMPublicationKeyDates?.publicationReviewDate | dateFormat}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="loading">
      <div class="flex justify-center items-center min-h-[40vh]">
        <div *ngIf="loading">
          <app-loading-indicator [size]="32"></app-loading-indicator>
        </div>
      </div>
  </ng-container>
</div>


